export default {
  // GirdMapの右メニューを4分割のどのマップで開いたかを返す
  rightMenuForGridSettingTarget: (state) => {
    const { activeSidebarForGrid: sidebarState } = state;
    if (sidebarState.isActive) return sidebarState.mapId;
    return "";
  },
  // FireStoreのGridMap用のtracking_targetがどの対象を保持しているかを返す
  getTrackingTarget: (state) => (trackingTarget) => {
    const setting = state.allGridMapSettings.find(
      (gms) => gms.map_id === trackingTarget.mapId,
    );
    if (
      setting &&
      setting.tracking_target &&
      setting.tracking_target.type === trackingTarget.type
    ) {
      return setting.tracking_target.id;
    }
    return "";
  },
};
